import {
  useDealersQuery,
  UseDealersQueryParams,
} from "../queries/useDealersQuery";
import { IPagination } from "../../../interfaces/IPagination";
import { DealerInterface } from "../../../interfaces/dealerInterface";

type Response = {
  dealers: DealerInterface[];
  paginationData?: IPagination;
  isLoading: boolean;
};

export const useDealers = (opt: UseDealersQueryParams): Response => {
  const { data, isLoading } = useDealersQuery(opt);
  return {
    dealers: data?.data?.dealers || [],
    paginationData: data?.data?.pagination,
    isLoading,
  };
};
